import moment from 'moment';
import * as types from '../actionType';
import * as Api from '../apiconfig';
import fetchFunc from './fecthFunc';

// 確認每個動作的token是否過期或有效 若失效則強制登出
const checkResponseTokenEffective = (response, dispatch) => {
  if (response.status === 403 || response.status === 401) {
    dispatch(logoutSuccess());
  } else if (response.status === 500) {
    dispatch(serverError());
  } else { return response.json(); }
};


export const fetchStart = () => dispatch => dispatch({ type: types.FETCH_START });
export const fetchEnd = () => dispatch => dispatch({ type: types.FETCH_END });

// API 狀態管理復原
export const InitAPIStatus = item => ({ type: types.INIT_SEND_API_STATUS });

// 登出
export const logoutSuccess = () => ({ type: types.LOGOUT_SUCCESS });

// 伺服器出錯
export const serverError = () => ({ type: types.SERVER_ERROR_500 });

export const updateStore = () => ({ type: types.UPDATE_STORE });

// 登入請求
export const adminLoginRequest = () => ({ type: types.ADMIN_LOGIN_REQUEST });
export const adminLoginSuccess = (result, username) => ({ type: types.ADMIN_LOGIN_SUCCESS, result, username });
export const adminLoginFailure = err => ({ type: types.ADMIN_LOGIN_FAILURE, err });
export function adminLoginRequestFunc(LoginObj) {
  const params = {
    grant_type: 'password',
    sys: 'CDWB',
    username: LoginObj.userName,
    password: LoginObj.password,
  };
  const searchParams = Object.keys(params).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join('&');
  return (dispatch) => {
    dispatch(adminLoginRequest());
    fetch(Api.loginAPI.POST, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: searchParams,
      mode: 'cors',
      cache: 'default',
    })
      .then(response => response.json())
      .then((json) => {
        const error_description = json.error_description.toString().trim();
        if (error_description === '3' || error_description === '4') {
          return dispatch(adminLoginFailure(error_description));
        }
        return dispatch(adminLoginSuccess(json, LoginObj.userName));
      })
      .catch((err) => { dispatch(adminLoginFailure(err)); });
  };
}
// 記住我
export const switchRememberMe = AdminObj => ({ type: types.SWITCH_REMEMBER_ME, AdminObj });

// 員工列表 by 頁數跟總顯示
export const staffListRequest = () => ({ type: types.STAFF_LIST_REQUEST });
export const staffListSuccess = result => ({ type: types.STAFF_LIST_SUCCESS, result });
export const staffListFailure = err => ({ type: types.STAFF_LIST_FAILURE, err });
export function getStaffList(page, countOfPage, keyword, status, storeId) {
  console.log(status)
  //console.log('1')
  // if (storeId === 'all'){
  //   console.log('2')

  //   var currentStoreId = localStorage.getItem('current_store_id');
  //   localStorage.setItem('current_store_id','0');
  //   localStorage.setItem('temp_store_id',currentStoreId);
  // }
  return (dispatch) => {
    dispatch(staffListRequest());
    let query = `${Api.staffListAPI.GET}?page=${page}&pageSize=${countOfPage}&status=${status}&keyword=${keyword}`;
    if (keyword.trim().length === 0) {
      query = `${Api.staffListAPI.GET}?page=${page}&pageSize=${countOfPage}&status=${status}`;
    }
    fetchFunc(query, storeId === 'all' ? 'GETALL' : 'GET')
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then(json => dispatch(staffListSuccess(json.result)))
      .catch((err) => { dispatch(staffListFailure(err)); });
  };
}

// 員工新增
export const addStaffRequest = () => ({ type: types.ADD_STAFF_REQUEST });
export const addStaffSuccess = result => ({ type: types.ADD_STAFF_SUCCESS, result });
export const addStaffFailure = err => ({ type: types.ADD_STAFF_FAILURE, err });
export function addStaff(staffData) {
  return (dispatch) => {
    // dispatch(staffListRequest());
    fetchFunc(Api.staffListAPI.Edit, 'POST', JSON.stringify(staffData))
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then((json) => {
        if (json.status === 1) {
          dispatch(editStaffSuccess());
        } else {
          dispatch(addStaffFailure(json.code));
        }
      })
      .catch((err) => { dispatch(addStaffFailure(err)); });
  };
}

// 員工編輯
export const editStaffRequest = () => ({ type: types.EDIT_STAFF_REQUEST });
export const editStaffSuccess = result => ({ type: types.EDIT_STAFF_SUCCESS, result });
export const editStaffFailure = err => ({ type: types.EDIT_STAFF_FAILURE, err });
export function editStaff(staffData) {
  return (dispatch) => {
    const query = `${Api.staffListAPI.Edit}/${staffData.id}`;
    fetchFunc(query, 'PUT', JSON.stringify(staffData))
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then((json) => {
        if (json.status === 1) {
          dispatch(editStaffSuccess());
          getStaffList(1, 10);
        } else {
          dispatch(editStaffFailure(json.code));
        }
      })
      .catch((err) => { dispatch(editStaffFailure(err)); });
  };
}

// 員工職位編輯
export const editStaffJobRequest = () => ({ type: types.EDIT_STAFF_REQUEST });
export const editStaffJobSuccess = result => ({ type: types.EDIT_STAFF_SUCCESS, result });
export const editStaffJobFailure = err => ({ type: types.EDIT_STAFF_FAILURE, err });
export function editStaffJob(staffData) {
  return (dispatch) => {
    const query = `${Api.staffListAPI.UPDATEUSERJOB}`;
    fetchFunc(query, 'POST', JSON.stringify(staffData))
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then((json) => {
        if (json.status === 1) {
          dispatch(editStaffJobSuccess());
          getStaffList(1, 10);
        } else {
          dispatch(editStaffJobFailure(json.code));
        }
      })
      .catch((err) => { dispatch(editStaffJobFailure(err)); });
  };
}

// 職位列表
export const jobTypeListRequest = () => ({ type: types.JOBTYPE_LIST_REQUEST });
export const jobTypeListSuccess = result => ({ type: types.JOBTYPE_LIST_SUCCESS, result });
export const jobTypeListFailure = err => ({ type: types.JOBTYPE_LIST_FAILURE, err });
export function getJobTypeList() {
  //因為要所有的會變0，打之前要檢查一下有沒有值
  // if(localStorage.getItem('current_store_id') === '0'){
  //   localStorage.setItem('current_store_id',localStorage.getItem('temp_store_id'))
  // }

  return (dispatch) => {

    dispatch(jobTypeListRequest());
    fetchFunc(Api.jobTypeAPI.GET, 'GET')
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then(json => dispatch(jobTypeListSuccess(json.result)))
      .catch((err) => { dispatch(jobTypeListFailure(err)); });
  };
}

// 員工狀態修改
export function switchStaffstatus(userData, currPage) {
  return (dispatch) => {
    const query = `${Api.staffListAPI.Edit}/${userData.userId}`;
    fetchFunc(query, 'PATCH', JSON.stringify({
      status: userData.status,
    }))
      .then(response => checkResponseTokenEffective(response, dispatch))
      .catch(error => console.error('Error:', error))
      .then((response) => {
        dispatch(getStaffList(currPage, 10, '',userData.status));
      });
  };
}

// 員工列表排序
export const sortStafflist = sortkey => ({ type: types.SORT_STAFF_LIST, sortkey });


// 該員工預期工時表
export const initNextShiftRequest = () => ({ type: types.NEXT_SHIFT_REQUEST });
export const getNextShiftSuccess = result => ({ type: types.NEXT_SHIFT_SUCCESS, result });
export const getNextShiftFailure = err => ({ type: types.NEXT_SHIFT_FAILURE, err });
export function getNextShift() {
  return (dispatch) => {
    dispatch(initNextShiftRequest());
    fetchFunc(`${Api.nextShiftAPI.GET}?timeOffset=8&resourceId=6,8,9,10`, 'GET')
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then(json => dispatch(getNextShiftSuccess(json.result)))
      .catch((err) => { dispatch(getNextShiftFailure(err)); });
  };
}

// 新增員工預期工時
export const addWorkTimeRequest = () => ({ type: types.ADD_NEXT_WORK_TIME_REQUEST });
export const addWorkTimeSucccess = result => ({ type: types.ADD_NEXT_WORK_TIME_SUCCESS, result });
export const addWorkTimeFailure = err => ({ type: types.ADD_NEXT_WORK_TIME_FAILURE, err });
export function addWorkTime(data) {
  return (dispatch) => {
    dispatch(addWorkTimeRequest());
    fetchFunc(`${Api.nextShiftAPI.GET}?timeOffset=8`, 'POST', JSON.stringify(data))
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then((json) => {
        // code 5 非填班時間
        if (json.status === 1) {
          dispatch(addWorkTimeSucccess(json.result));
        } else {
          dispatch(addWorkTimeFailure(json.code));
        }
      })
      .catch((err) => { dispatch(addWorkTimeFailure(err)); });
  };
}

// 編輯員工預期工時
export const editWorkTimeRequest = () => ({ type: types.EDIT_NEXT_WORK_TIME_REQUEST });
export const editWorkTimeSucccess = result => ({ type: types.EDIT_NEXT_WORK_TIME_SUCCESS, result });
export const editWorkTimeFailure = err => ({ type: types.EDIT_NEXT_WORK_TIME_FAILURE, err });
export function editWorkTime(data, callback) {
  return (dispatch) => {
    dispatch(editWorkTimeRequest());
    fetchFunc(Api.nextShiftAPI.GET, 'PUT', JSON.stringify(data))
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then((json) => {
        // code 5 非填班時間
        if (json.status === 1) {
          if (callback) {
            callback();
          } else {
            dispatch(editWorkTimeSucccess(json.result));
          }
        } else {
          dispatch(editWorkTimeFailure(json.code));
        }
      })
      .catch((err) => { dispatch(editWorkTimeFailure(err)); });
  };
}

// 刪除員工預期工時
export const deleteWorkTimeRequest = () => ({ type: types.DELETE_NEXT_WORK_TIME_REQUEST });
export const deleteWorkTimeSucccess = result => ({ type: types.DELETE_NEXT_WORK_TIME_SUCCESS, result });
export const deleteWorkTimeFailure = err => ({ type: types.DELETE_NEXT_WORK_TIME_FAILURE, err });
export function deleteWorkTime(data) {
  return (dispatch) => {
    dispatch(deleteWorkTimeRequest());
    fetchFunc(Api.nextShiftAPI.GET, 'DELETE', JSON.stringify(data))
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then((json) => {
        // code 5 非填班時間
        if (json.status === 1) {
          dispatch(deleteWorkTimeSucccess(data));
        } else {
          dispatch(editWorkTimeFailure(json.code));
        }
      })
      .catch((err) => { dispatch(deleteWorkTimeFailure(err)); });
  };
}

// 支援班表
export const initSupportScheduleShiftRequest = () => ({ type: types.SUPPORT_SCHEDULE_SHIFT_REQUEST });
export const getSupportScheduleShiftSuccess = result => ({ type: types.SUPPORT_SCHEDULE_SHIFT_SUCCESS, result });
export const getSupportScheduleShiftFailure = err => ({ type: types.SUPPORT_SCHEDULE_SHIFT_FAILURE, err });
export function getSupportScheduleShift() {
  return (dispatch) => {
    dispatch(initSupportScheduleShiftRequest());
    fetchFunc(`${Api.ScheduleAPI.SUPPORT}?timeOffset=8`, 'GET')
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then(json => dispatch(getSupportScheduleShiftSuccess(json.result)))
      .catch((err) => { dispatch(getSupportScheduleShiftFailure(err)); });
  };
}

// 支援班表 BY DATE
export const initSupportScheduleShiftDateRequest = () => ({ type: types.SUPPORT_SCHEDULE_SHIFT_REQUEST_BY_DATE });
export const getSupportScheduleShiftDateSuccess = result => ({ type: types.SUPPORT_SCHEDULE_SHIFT_SUCCESS_BY_DATE, result });
export const getSupportScheduleShiftDateFailure = err => ({ type: types.SUPPORT_SCHEDULE_SHIFT_FAILURE_BY_DATE, err });
export function getSupportScheduleShiftDate(date) {
  return (dispatch) => {
    dispatch(initSupportScheduleShiftDateRequest());
    fetchFunc(`${Api.ScheduleAPI.SUPPORTDETAIL}?date=${date}`, 'GET')
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then(json => dispatch(getSupportScheduleShiftDateSuccess(json.result)))
      .catch((err) => { dispatch(getSupportScheduleShiftDateFailure(err)); });
  };
}

// 個人簽到資料
export const initPersonalAttendance = () => ({ type: types.ATTENDANCE_SHEET_REQUEST });
export const getPersonalAttendanceSuccess = result => ({ type: types.ATTENDANCE_SHEET_SUCCESS, result });
export const getPersonalAttendanceFailure = err => ({ type: types.ATTENDANCE_SHEET_FAILURE, err });
export function getPersonalAttendance({
  start, end, page, pageSize,
}) {
  return (dispatch) => {
    const query = `${Api.ScheduleAPI.ATTENDANCE}?timeOffset=8&start=${start}&end=${end}&page=${page}&pageSize=${pageSize}`;
    dispatch(initPersonalAttendance());
    fetchFunc(query, 'GET')
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then(json => dispatch(getPersonalAttendanceSuccess(json.result)))
      .catch((err) => { dispatch(getPersonalAttendanceFailure(err)); });
  };
}

// 總簽到資料
export const initAllAttendance = () => ({ type: types.ALL_ATTENDANCE_SHEET_REQUEST });
export const getAllAttendanceSuccess = result => ({ type: types.ALL_ATTENDANCE_SHEET_SUCCESS, result });
export const getAllAttendanceFailure = err => ({ type: types.ALL_ATTENDANCE_SHEET_FAILURE, err });
export function getAllAttendance({
  start, end, page, pageSize, keyword,
}) {
  return (dispatch) => {
    let query = `${Api.ScheduleAPI.ATTENDANCE}/All?timeOffset=8&start=${start}&end=${end}&page=${page}&pageSize=${pageSize}`;
    if (keyword.trim().length !== 0) {
      query = `${Api.ScheduleAPI.ATTENDANCE}/All?timeOffset=8&start=${start}&end=${end}&page=${page}&pageSize=${pageSize}&keyword=${keyword}`;
    }
    dispatch(initAllAttendance());
    fetchFunc(query, 'GET')
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then(json => dispatch(getAllAttendanceSuccess(json.result)))
      .catch((err) => { dispatch(getAllAttendanceFailure(err)); });
  };
}


// 預期工時班表
export const initExpectedWorkRequest = () => ({ type: types.EXPECTED_WORK_SHEET_REQUEST });
export const getExpectedWorkSuccess = result => ({ type: types.EXPECTED_WORK_SHEET_SUCCESS, result });
export const getExpectedWorkFailure = err => ({ type: types.EXPECTED_WORK_SHEET_FAILURE, err });
export function getExpectedWorkSheet(start, end) {
  return (dispatch) => {
    let query = `${Api.ScheduleAPI.EXPECTED}?timeOffset=8&start=&end=`;
    if (start) {
      query = `${Api.ScheduleAPI.EXPECTED}?timeOffset=8&start=${start}&end=${end}`;
    }
    dispatch(initExpectedWorkRequest());
    fetchFunc(query, 'GET')
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then(json => dispatch(getExpectedWorkSuccess(json.result)))
      .catch((err) => { dispatch(getExpectedWorkFailure(err)); });
  };
}

// 當日預期成本 by day
export const initExpectedWorkBydayRequest = () => ({ type: types.EXPECTED_WORKBYDAY_SHEET_REQUEST });
export const getExpectedWorBydaykSuccess = result => ({ type: types.EXPECTED_WORKBYDAY_SHEET_SUCCESS, result });
export const getExpectedWorkBydayFailure = err => ({ type: types.EXPECTED_WORKBYDAY_SHEET_FAILURE, err });
export function getExpectedWorkBydaySheet(date) {
  return (dispatch) => {
    dispatch(initExpectedWorkBydayRequest());
    fetchFunc(`${Api.ScheduleAPI.EXPECTEDBYDATE}?date=${date}`, 'GET')
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then(json => dispatch(getExpectedWorBydaykSuccess(json.result)))
      .catch((err) => { dispatch(getExpectedWorkBydayFailure(err)); });
  };
}

// 最終工時班表
export const initFinalWorkRequest = () => ({ type: types.FINAL_WORK_SHEET_REQUEST });
export const getFinalWorkSuccess = result => ({ type: types.FINAL_WORK_SHEET_SUCCESS, result });
export const getFinalWorkFailure = err => ({ type: types.FINAL_WORK_SHEET_FAILURE, err });
export function getFinalWorkSheet(timeoffset,start,end) {
  return (dispatch) => {
    dispatch(initFinalWorkRequest());
    fetchFunc(`${Api.ScheduleAPI.FINAL}?timeOffset=${timeoffset}&start=${start}&end=${end}`, 'GET')
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then(json => dispatch(getFinalWorkSuccess(json.result)))
      .catch((err) => { dispatch(getFinalWorkFailure(err)); });
  };
}

// 當日最終成本 by day
export const initFinalWorkBydayRequest = () => ({ type: types.FINAL_WORKBYDAY_SHEET_REQUEST });
export const getFinalWorBydaykSuccess = result => ({ type: types.FINAL_WORKBYDAY_SHEET_SUCCESS, result });
export const getFinalWorkBydayFailure = err => ({ type: types.FINAL_WORKBYDAY_SHEET_FAILURE, err });
export function getFinalWorkBydaySheet(date) {
  return (dispatch) => {
    dispatch(initFinalWorkBydayRequest());
    fetchFunc(`${Api.ScheduleAPI.FINALBYDATE}?date=${date}`, 'GET')
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then(json => dispatch(getFinalWorBydaykSuccess(json.result)))
      .catch((err) => { dispatch(getFinalWorkBydayFailure(err)); });
  };
}

// 取得欲調整班表
export const initAdjustmentScheduleRequest = () => ({ type: types.ADJUSTMENT_SCHEDULE_SHEET_REQUEST });
export const getAdjustmentScheduleSuccess = result => ({ type: types.ADJUSTMENT_SCHEDULE_SHEET_SUCCESS, result });
export const getAdjustmentScheduleFailure = err => ({ type: types.ADJUSTMENT_SCHEDULE_SHEET_FAILURE, err });
export function getAdjustmentSchedule() {
  return (dispatch) => {
    dispatch(initAdjustmentScheduleRequest());
    fetchFunc(`${Api.ScheduleAPI.ADJUSTMENTSCHEDULE}?timeOffset=8`, 'GET')
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then(json => dispatch(getAdjustmentScheduleSuccess(json.result)))
      .catch((err) => { dispatch(getAdjustmentScheduleFailure(err)); });
  };
}

// 取得欲調整班表 by 日期
export const initAdjustmentScheduleDetailRequest = () => ({ type: types.ADJUSTMENT_SCHEDULE_SHEET_DETAIL_REQUEST });
export const getAdjustmentScheduleDetailSuccess = result => ({ type: types.ADJUSTMENT_SCHEDULE_SHEET_DETAIL_SUCCESS, result });
export const getAdjustmentScheduleDetailFailure = err => ({ type: types.ADJUSTMENT_SCHEDULE_SHEET_DETAIL_FAILURE, err });
export function getAdjustmentScheduleDetail(date, isAll) {
  return (dispatch) => {
    dispatch(initAdjustmentScheduleDetailRequest());
    fetchFunc(`${Api.ScheduleAPI.ADJUSTMENTSCHEDULEDETAIL}?date=${date}&getAll=${isAll}`, 'GET')
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then(json => dispatch(getAdjustmentScheduleDetailSuccess(json.result)))
      .catch((err) => { dispatch(getAdjustmentScheduleDetailFailure(err)); });
  };
}


// 調班時新增調班人員
export const initAddStaffInAdjustShiftRequest = () => ({ type: types.ADD_STAFF_IN_ADJUST_SHIFT_REQUEST });
export const getAddStaffInAdjustShiftSuccess = result => ({ type: types.ADD_STAFF_IN_ADJUST_SHIFT_SUCCESS, result });
export const getAddStaffInAdjustShiftFailure = err => ({ type: types.ADD_STAFF_IN_ADJUST_SHIFT_FAILURE, err });
export function addStaffInAdjustShift(data) {
  return (dispatch) => {
    dispatch(initAddStaffInAdjustShiftRequest());
    fetchFunc(`${Api.ScheduleAPI.ADDSTAFFINADJUST}?timeOffset=8`, 'POST', JSON.stringify(data))
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then((json) => {
        dispatch(getAdjustmentScheduleDetail(data.start.substring(0, 10), false));
      })
      .catch((err) => { dispatch(getAddStaffInAdjustShiftFailure(err)); });
  };
}

// 獲取全部的員工
export const initGetAllStaffRequest = () => ({ type: types.GET_ALL_STAFF_REQUEST });
export const getAllStaffSuccess = result => ({ type: types.GET_ALL_STAFF_SUCCESS, result });
export const getAllStaffFailure = err => ({ type: types.GET_ALL_STAFF_FAILURE, err });
export function getAllStaff() {
  return (dispatch) => {
    dispatch(initGetAllStaffRequest());
    fetchFunc(Api.staffListAPI.GETALL, 'GET')
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then(json => dispatch(getAllStaffSuccess(json.result)))
      .catch((err) => { dispatch(getAllStaffFailure(err)); });
  };
}

// 獲取假單
export const initGetAllLeaveRecRequest = () => ({ type: types.GET_ALL_LEAVEREC_REQUEST });
export const getAllLeaveRecSuccess = result => ({ type: types.GET_ALL_LEAVEREC_SUCCESS, result });
export const getAllLeaveRecFailure = err => ({ type: types.GET_ALL_LEAVEREC_FAILURE, err });
export function getAllLeaveRec(status) {
  return (dispatch) => {
    dispatch(initGetAllLeaveRecRequest());
    fetchFunc(Api.leaveRecAPI.GET + '/' + status, 'GET')
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then(json => dispatch(getAllLeaveRecSuccess(json.result)))
      .catch((err) => { dispatch(getAllLeaveRecFailure(err)); });
  };
}

// 刪除員工工時 調整表
export const deleteStaffInAdjustRequest = () => ({ type: types.DELETE_STAFF_IN_ADJUST_REQUEST });
export const deleteStaffInAdjustSucccess = result => ({ type: types.DELETE_STAFF_IN_ADJUST_SUCCESS, result });
export const deleteStaffInAdjustFailure = err => ({ type: types.DELETE_STAFF_IN_ADJUST_FAILURE, err });
export function deleteStaffInAdjust(id, callback) {
  return (dispatch) => {
    dispatch(deleteStaffInAdjustRequest());
    fetchFunc(Api.nextShiftAPI.GET, 'DELETE', JSON.stringify({ id }))
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then((json) => {
        if (json.status === 1) {
          if (callback) {
            callback();
          } else {
            dispatch(deleteStaffInAdjustSucccess(json.result));
          }
        } else {
          dispatch(deleteStaffInAdjustFailure(json.code));
        }
      })
      .catch((err) => { dispatch(deleteStaffInAdjustFailure(err)); });
  };
}

// 員工工時 調整表
export const editStaffWorkTimeInAdjustRequest = () => ({ type: types.EDIT_STAFF_WORKTIME_IN_ADJUST_REQUEST });
export const editStaffWorkTimeInAdjustSucccess = result => ({ type: types.EDIT_STAFF_WORKTIME_IN_ADJUST_SUCCESS, result });
export const editStaffWorkTimeInAdjustFailure = err => ({ type: types.EDIT_STAFF_WORKTIME_IN_ADJUST_FAILURE, err });
export function editStaffWorkTimeInAdjust(data) {
  return (dispatch) => {
    dispatch(editStaffWorkTimeInAdjustRequest());
    fetchFunc(Api.nextShiftAPI.GET, 'PUT', JSON.stringify(data))
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then((json) => {
        if (json.status === 1) {
          dispatch(editStaffWorkTimeInAdjustSucccess(data));
        } else {
          dispatch(editStaffWorkTimeInAdjustFailure(json.code));
        }
      })
      .catch((err) => { dispatch(editStaffWorkTimeInAdjustFailure(err)); });
  };
}


// 獲取全部的員工薪資
export const initGetAllStaffSalaryRequest = () => ({ type: types.GET_STAFF_SALARY_LIST_REQUEST });
export const getAllStaffSalarySuccess = result => ({ type: types.GET_STAFF_SALARY_LIST_SUCCESS, result });
export const getAllStaffFSalaryFailure = err => ({ type: types.GET_STAFF_SALARY_LIST_FAILURE, err });
export function getStaffSalaryList(date) {
  return (dispatch) => {
    dispatch(initGetAllStaffSalaryRequest());
    fetchFunc(`${Api.ScheduleAPI.EMPLOYEESALARYSHEET}?date=${date}`, 'GET')
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then(json => dispatch(getAllStaffSalarySuccess(json.result)))
      .catch((err) => { dispatch(getAllStaffFSalaryFailure(err)); });
  };
}


// 新增員工上班紀錄
export const addStaffWorkRecordRequest = () => ({ type: types.ADD_STAFF_WORK_RECORD_REQUEST });
export const addStaffWorkRecordSuccess = result => ({ type: types.ADD_STAFF_WORK_RECORD_SUCCESS, result });
export const addStaffWorkRecordFailure = err => ({ type: types.ADD_STAFF_WORK_RECORD_FAILURE, err });
export function addStaffWorkRecord(data, callback) {
  return (dispatch) => {
    dispatch(addStaffWorkRecordRequest());
    fetchFunc(`${Api.ScheduleAPI.ADDSTAFFINADJUST}?timeOffset=8`, 'POST', JSON.stringify(data))
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then((json) => {
        const start = `${moment().add(0, 'month').format('YYYY-MM')}-01`;
        const end = moment(start).add(1, 'month').add(-1, 'days').format('YYYY-MM-DD');
        dispatch(getAllAttendance({
          start, end, page: Math.ceil(json.result.count / 10), pageSize: 10, keyword: '',
        }));
        callback(Math.ceil(json.result.count / 10));
      })
      .catch((err) => { dispatch(addStaffWorkRecordFailure(err)); });
  };
}


// 補簽到
export const reAddWorkTimeRequest = () => ({ type: types.RE_ADD_STAFF_WORK_RECORD_REQUEST });
export const reAddWorkTimeSucccess = result => ({ type: types.RE_ADD_STAFF_WORK_RECORD_SUCCESS, result });
export const reAddWorkTimeFailure = err => ({ type: types.RE_ADD_STAFF_WORK_RECORD_FAILURE, err });
export function reAddWorkTime(data, page, start, end) {
  return (dispatch) => {
    dispatch(reAddWorkTimeRequest());
    fetchFunc(`${Api.ScheduleAPI.ACTIVE}?timeOffset=8`, 'PUT', JSON.stringify(data))
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then((json) => {
        dispatch(getAllAttendance({
          start, end, page, pageSize: 10, keyword: '',
        }));
      })
      .catch((err) => { dispatch(reAddWorkTimeFailure(err)); });
  };
}


// 獲取當日彙整資料
export const initGetPeopleStatisticsRequest = () => ({ type: types.PEOPLESTATICTICS_SHEET_DETAIL_REQUEST });
export const getPeopleStatisticsSuccess = result => ({ type: types.PEOPLESTATICTICS_SHEET_DETAIL_SUCCESS, result });
export const getPeopleStatisticsFailure = err => ({ type: types.PEOPLESTATICTICS_SHEET_DETAIL_FAILURE, err });
export function peopleStatisticsList(date) {
  return (dispatch) => {
    dispatch(initGetPeopleStatisticsRequest());
    fetchFunc(`${Api.ScheduleAPI.PeopleStatistic}?date=${date}`, 'GET')
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then(json => dispatch(getPeopleStatisticsSuccess(json.result)))
      .catch((err) => { dispatch(getPeopleStatisticsFailure(err)); });
  };
}

// 新增打卡紀錄
export const initAddPunchTimeRecordRequest = () => ({ type: types.ADD_PUNCHTIME_RECORD_REQUEST });
export const addPunchTimeRecordSuccess = () => ({ type: types.ADD_PUNCHTIME_RECORD_SUCCESS });
export const addPunchTimeRecordFailure = err => ({ type: types.ADD_PUNCHTIME_RECORD_FAILURE, err });
export function addPunchTimeRecord(data) {
  return (dispatch) => {
    dispatch(initAddPunchTimeRecordRequest());
    fetchFunc(Api.ScheduleAPI.PunchTime, 'POST', JSON.stringify(data))
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then((json) => {
        dispatch(editPunchTimeRecordSuccess());
      })
      .catch((err) => { dispatch(addPunchTimeRecordFailure(err)); });
  };
}


// 更新打卡紀錄
export const initEditPunchTimeRecordRequest = () => ({ type: types.EDIT_PUNCHTIME_RECORD_REQUEST });
export const editPunchTimeRecordSuccess = () => ({ type: types.EDIT_PUNCHTIME_RECORD_SUCCESS });
export const editPunchTimeRecordFailure = err => ({ type: types.EDIT_PUNCHTIME_RECORD_FAILURE, err });
export function editPunchTimeRecord(data) {
  return (dispatch) => {
    dispatch(initEditPunchTimeRecordRequest());
    fetchFunc(Api.ScheduleAPI.PunchTime, 'PUT', JSON.stringify(data))
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then((json) => {
        dispatch(editPunchTimeRecordSuccess());
      })
      .catch((err) => { dispatch(editPunchTimeRecordFailure(err)); });
  };
}


// 更新打卡紀錄
export const initGetSignInOutHistory = () => ({ type: types.GET_SIGNINOUT_REQUEST });
export const getSignInOutHistorySuccess = result => ({ type: types.GET_SIGNINOUT_SUCCESS, result });
export const getSignInOutHistoryFailure = err => ({ type: types.GET_SIGNINOUT_FAILURE, err });
export function getSignInOutHistory(ids, callback) {
  return (dispatch) => {
    let string = '';
    ids.forEach((id) => {
      if (id === '無資料') {} else {
        if (string.length !== 0) {
          string += ',';
        }
        string += id;
      }
    });
    if (string.length === 0) {
      return;
    }
    const query = `${Api.ScheduleAPI.PunchTimeHistory}?actualEventId=${string}`;
    dispatch(initGetSignInOutHistory());
    fetchFunc(query, 'GET')
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then((json) => {
        dispatch(getSignInOutHistorySuccess(json.result));
        callback();
      })
      .catch((err) => { dispatch(getSignInOutHistoryFailure(err)); });
  };
}

// 取得單日人事成本表 by 日期
export const initDailyCostByHourRequest = () => ({ type: types.DAILY_COST_BY_HOUR_REQUEST });
export const getDailyCostByHourSuccess = result => ({ type: types.DAILY_COST_BY_HOUR_SUCCESS, result });
export const getDailyCostByHourFailure = err => ({ type: types.DAILY_COST_BY_HOUR_FAILURE, err });
export function getDailyCostByHourDetail(date, isAll) {
  return (dispatch) => {
    dispatch(initDailyCostByHourRequest());
    fetchFunc(`${Api.ScheduleAPI.ACTUALEVENTDETAIL}?date=${date}&getAll=${isAll}`, 'GET')
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then(json => dispatch(getDailyCostByHourSuccess(json.result)))
      .catch((err) => { dispatch(getDailyCostByHourFailure(err)); });
  };
}

// 取得單日收支表 by 日期
export const initHourCostChartRequest = () => ({ type: types.HOUR_COST_CHART_REQUEST });
export const getHourCostChartSuccess = result => ({ type: types.HOUR_COST_CHART_SUCCESS, result });
export const getHourCostChartFailure = err => ({ type: types.HOUR_COST_CHART_FAILURE, err });
export function getHourCostChart(date,department) {
  return (dispatch) => {
    dispatch(initHourCostChartRequest());
    fetchFunc(`${Api.ScheduleAPI.HOURCOSTCHART}?date=${date}&department=${department}`, 'GET')
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then(json => dispatch(getHourCostChartSuccess(json.result)))
      .catch((err) => { dispatch(getHourCostChartFailure(err)); });
  };
}

export const init30MinCostChartRequest = () => ({ type: types.MIN30_COST_CHART_REQUEST });
export const get30MinCostChartSuccess = result => ({ type: types.MIN30_COST_CHART_SUCCESS, result });
export const get30MinCostChartFailure = err => ({ type: types.MIN30_COST_CHART_FAILURE, err });
export function get30MinCostChart(date,department) {
  return (dispatch) => {
    dispatch(init30MinCostChartRequest());
    fetchFunc(`${Api.ScheduleAPI.MIN30COSTCHART}?date=${date}&department=${department}`, 'GET')
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then(json => dispatch(get30MinCostChartSuccess(json.result)))
      .catch((err) => { dispatch(get30MinCostChartFailure(err)); });
  };
}

export const init30MinBarCostChartRequest = () => ({ type: types.MIN30BAR_COST_CHART_REQUEST });
export const get30MinBarCostChartSuccess = result => ({ type: types.MIN30BAR_COST_CHART_SUCCESS, result });
export const get30MinBarCostChartFailure = err => ({ type: types.MIN30BAR_COST_CHART_FAILURE, err });
export function get30MinBarCostChart(date,department) {
  return (dispatch) => {
    dispatch(init30MinBarCostChartRequest());
    fetchFunc(`${Api.ScheduleAPI.MIN30COSTCHART}?date=${date}&department=${department}`, 'GET')
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then(json => dispatch(get30MinBarCostChartSuccess(json.result)))
      .catch((err) => { dispatch(get30MinBarCostChartFailure(err)); });
  };
}

// 取得累計收支表 by 日期
export const initAccumulateCostChartRequest = () => ({ type: types.ACCUMULATE_COST_CHART_REQUEST });
export const getAccumulateCostChartSuccess = result => ({ type: types.ACCUMULATE_COST_CHART_SUCCESS, result });
export const getAccumulateCostChartFailure = err => ({ type: types.ACCUMULATE_COST_CHART_FAILURE, err });
export function getAccumulateCostChart(date,department) {
  return (dispatch) => {
    dispatch(initAccumulateCostChartRequest());
    fetchFunc(`${Api.ScheduleAPI.ACCUMULATECOSTCHART}?date=${date}&department=${department}`, 'GET')
      .then(response => checkResponseTokenEffective(response, dispatch))
      .then(json => dispatch(getAccumulateCostChartSuccess(json.result)))
      .catch((err) => { dispatch(getAccumulateCostChartFailure(err)); });
  };
}